import api from './axios';

export function getPermissionMatrix() {
  return api.get('/permissions/matrix').then((r) => r.data);
}

export function putRolePermissions(role, permissionKeys) {
  return api.put(`/permissions/roles/${encodeURIComponent(role)}`, { permission_keys: permissionKeys }).then((r) => r.data);
}

export function listPermissionDelegates(params) {
  return api.get('/permissions/delegates', { params }).then((r) => r.data);
}

export function grantUserPermission(userId, permissionKey) {
  return api.post(`/permissions/users/${userId}/grants`, { permission_key: permissionKey }).then((r) => r.data);
}

export function revokeUserPermission(userId, permissionKey) {
  return api
    .delete(`/permissions/users/${userId}/grants`, { params: { permission_key: permissionKey } })
    .then((r) => r.data);
}
